import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { firstTruthy } from '@shared/rxjs-operators';
import { License } from '@shared/types';
import { map } from 'rxjs';
import { LicensesService } from '../services/licenses.service';

export const licensesCanMatch =
    (requiredLicenses: License | License[]): CanMatchFn =>
    () => {
        return inject(LicensesService).licensesObs.pipe(
            firstTruthy(),
            map((licenses) => [requiredLicenses].flat().some((requiredLicense) => licenses.has(requiredLicense))),
        );
    };
